import React, { useState } from 'react';
import { Modal, Form, Select, Input } from 'antd';

interface CancelPopupProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: { commentFor: string; comment: string }) => void;
  isLoading?: boolean;
}

const CancelPopup: React.FC<CancelPopupProps> = ({ visible, onClose, onSubmit, isLoading = false }) => {
  const [form] = Form.useForm();

  return (
    <Modal title="Cancel Task" open={visible} onOk={() => form.submit()} confirmLoading={isLoading} onCancel={onClose}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="commentFor"
          label="Comment For"
          rules={[{ required: true, message: 'Please select an option' }]}
        >
          <Select placeholder="Select">
            <Select.Option value="CUSTOMER">Customer</Select.Option>
            <Select.Option value="USER">System Admin</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="comment" label="Comment" rules={[{ required: true, message: 'Please enter a comment' }]}>
          <Input.TextArea placeholder="Enter your comment" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CancelPopup;
